module.exports = __webpack_public_path__ + "static/media/Devashree Desai.830cffd9.png";